import React, {PureComponent} from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from "@material-ui/core/Button"
import Paper from "@material-ui/core/Paper"
import Typography from '@material-ui/core/Typography';
import {ModalShow} from 'components/common/Modal';
import {modalHide} from 'actions/modal';
import styles from './styles.module.sass';


@connect()
class Question extends PureComponent {

  onOk = () => {
    const {onOk, dispatch} = this.props;
    dispatch(modalHide());
    if (onOk) onOk();
  };

  onCancel = () => {
    const {onCancel, dispatch} = this.props;
    dispatch(modalHide());
    if (onCancel) onCancel();
  };

  render() {
    const {header, ok, cancel, children, className} = this.props;

    return (
      <ModalShow
        className={className}
        component={(
          <Paper className={styles.modalBox}>
            <div className={styles.headerBox}><Typography className={styles.header}>{header}</Typography></div>
            <div className={styles.buttonBox}>
              <Button
                className={cx(styles.button)}
                variant='contained'
                color='primary'
                onClick={this.onOk}
              >
                {ok}
              </Button>
              <Button
                className={cx(styles.button)}
                variant='contained'
                onClick={this.onCancel}
              >
                {cancel}
              </Button>
            </div>
          </Paper>
        )}
      >
        {children}
      </ModalShow>
    );
  }
}

Question.propTypes = {
  className: PropTypes.string,
  children: PropTypes.element,

  header: PropTypes.string,

  ok: PropTypes.string,
  cancel: PropTypes.string,

  onOk: PropTypes.func,
  onCancel: PropTypes.func,
};

Question.defaultProps = {
  ok: 'Ок',
  cancel: 'Отмена',
};

export default Question;


// WEBPACK FOOTER //
// ./src/components/common/Question/Question.jsx